import { colors, COLORS } from '@constants/colors';

const PANEL_BG =
  'linear-gradient(135deg, rgba(28, 28, 34, 0.88) 0%, rgba(16, 16, 20, 0.88) 100%)';
const PANEL_BORDER = '1px solid rgba(255, 255, 255, 0.08)';
const PANEL_RADIUS = '14px';
const PANEL_BLUR = 'blur(18px)';

export const useEditorStyles = () => ({
  glassPanel: {
    background: PANEL_BG,
    border: PANEL_BORDER,
    borderRadius: PANEL_RADIUS,
    backdropFilter: PANEL_BLUR,
    color: COLORS.WHITE,
    boxShadow: '0 14px 40px rgba(0, 0, 0, 0.35)',
  },

  root: {
    position: 'fixed',
    inset: 0,
    pointerEvents: 'none',
    zIndex: 1200,
  },

  sceneTreeWrap: {
    position: 'absolute',
    top: '96px',
    bottom: '112px',
    left: '40px',
    width: '340px',
    pointerEvents: 'auto',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  sceneTreeCollapsedPill: {
    position: 'absolute',
    top: '96px',
    left: '40px',
    pointerEvents: 'auto',
    padding: '8px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    color: COLORS.WHITE,
    fontSize: '13px',
    fontWeight: 500,
    '&:hover': {
      background:
        'linear-gradient(135deg, rgba(38, 38, 46, 0.92) 0%, rgba(22, 22, 28, 0.92) 100%)',
    },
  },

  inspectorWrap: {
    position: 'absolute',
    top: '96px',
    // Hug the panel's height instead of spanning to a fixed bottom. A fixed
    // top + bottom made the wrapper taller than its content, so the empty
    // lower area showed the 3D scene through it and swallowed clicks meant for
    // the scene. maxHeight keeps the same scroll cap the panel itself uses
    // (calc(100vh - 208px) == old top 96px + bottom 112px).
    maxHeight: 'calc(100vh - 208px)',
    right: '40px',
    width: '360px',
    pointerEvents: 'auto',
    overflow: 'hidden',
    // Match the underlying inspector panel's corner radius so the wrapper's
    // overflow:hidden clips flush with the rounded panel instead of square.
    borderRadius: '20px',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },

  brandingBarWrap: {
    position: 'absolute',
    bottom: '100px',
    left: '50%',
    transform: 'translateX(-50%)',
    pointerEvents: 'auto',
  },

  panelHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 14px 8px',
  },
  panelTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: COLORS.WHITE,
  },
  panelTitleIcon: {
    fontSize: 18,
    color: colors.white_60,
  },
  panelTitle: {
    color: COLORS.WHITE,
    fontSize: '14px',
    fontWeight: 600,
  },
  panelSubtitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginLeft: '26px',
    minWidth: 0,
  },
  panelSubtitle: {
    color: colors.white_50,
    fontSize: '11px',
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  },
  panelSubtitleCopy: {
    color: colors.white_50,
    padding: '2px',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
      color: COLORS.WHITE,
    },
  },
  panelSubtitleSize: {
    flexShrink: 0,
    color: colors.white_50,
    fontSize: '10px',
    fontWeight: 600,
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    letterSpacing: '0.02em',
    whiteSpace: 'nowrap',
    padding: '1px 6px',
    borderRadius: '5px',
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    border: '1px solid rgba(255, 255, 255, 0.12)',
  },
  panelIconButton: {
    color: colors.white_60,
    padding: '4px',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
      color: COLORS.WHITE,
    },
  },
  panelBody: {
    padding: '4px 10px 12px',
    overflowY: 'auto',
    flex: 1,
    minHeight: 0,
  },
});
